<template>
  <b-modal id="BSReviewModalID" centered size="lg" @show="showMe">
    <template #modal-header>
      <h2 class="modal-title" v-if="review_id==0">{{ $t("buttons.addreview") }}</h2>
      <h2 v-else>{{description}}</h2>
    </template>

    <form class="form">
      <div class="form-row"  v-if="current_user && current_user.role == 'admin'">
        <div class="col-3">
          <label for=""> {{ $t("labels.title") }}</label>
        </div>
        <div class="col"  >
          <b-input-group>
            <b-form-textarea size="sm" rows="4"
              class="form-control" v-model="description" />
          </b-input-group>            
        </div>
      </div>
      <h4>Vragen (sleep om volgorde aan te passen)</h4>
      <div class="questionsselected" id="questionsselected">
        <div class="selectedquestion" v-for="(rq,idx) in filterAvailablequestions()" :key="idx" v-bind:value="rq" draggable 
        @dragstart="startQuestion($event,rq)" @dragover="handleDragover" @dragleave="handleDragleave" @drop="handleDrop">
        {{rq}}</div>
      </div>
      <b-table :items=reviewquestions  @row-clicked="onquestionClick">
        <template #cell(id)="row">
        <font-awesome-icon v-if="requestquestions.filter(rq=>rq==row.item.id).length>0" icon="check" style="color: green;"
          :title="$t('labels.editbrancheoff')" />
        <font-awesome-icon v-else icon="times" style="color: red;" :title="$t('labels.editbrancheon')" /> {{row.item.id}}
      </template>
        <template #cell(question_type)="row">
          <span v-if="row.item.question_type==1">{{ $t("labels.questiontype1") }}</span>
          <span v-if="row.item.question_type==2">{{ $t("labels.questiontype2") }}</span>
          <span v-if="row.item.question_type==3">{{ $t("labels.questiontype3") }}</span>
        </template>
    </b-table>    </form>

    <template #modal-footer>
      <div @click="saveData" class="btn btn-primary">
       {{ $t('buttons.saveandclose') }}
      </div>
    </template>
  </b-modal>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'invoice-data-modal',
  data() {
    return {
      description:"",
      reviewquestions:[],
      requestquestions:[],
      dragging:null
    }
  },
  props: {
    review_id: Number
  },
  computed: {

    ...mapState([
      'invoiceextra',
      'current_user',

    ]),
    ...mapGetters([
    'append_data_string',

    ]),
    questions(){
      return JSON.stringify(this.requestquestion)
    }

  },
  mounted(){
  this.showMe()      
    
  },
  methods: {
    startQuestion(evt){
      this.dragging = evt.currentTarget
    },
    handleDragover(event) {
      event.preventDefault(); // @note This is needed for drop to fire.
      event.currentTarget.classList.add("over");
    }, 
    handleDragleave(event) {
      event.currentTarget.classList.remove("over");
    }, 
    handleDrop(event) {
      let p =event.currentTarget.innerHTML 
      event.currentTarget.innerHTML = this.dragging.innerHTML
      this.dragging.innerHTML = p
      event.currentTarget.classList.remove("over");
      let holder = document.getElementById("questionsselected")
      var divs = holder.getElementsByTagName("div");
      this.requestquestions = []
      for(var i = 0; i < divs.length; i++){
        this.requestquestions.push(parseInt(divs[i].innerHTML))
      }
    },

    filterAvailablequestions(){
      let res=[]
      this.requestquestions.forEach(r=>{
        if(this.reviewquestions.filter(rq=>rq.id==r).length>0){
          res.push(r)
        }
      })
      return res

    },
    saveData(){
        axios.post('/api/reviewrequest/'+this.review_id, {id:this.review_id,description:this.description, questions:JSON.stringify(this.filterAvailablequestions())})
        .then(async () => {
          this.$emit('refresh', null)

          this.$bvModal.hide('BSReviewModalID')
        })

    },
    onquestionClick(row){
      if(this.requestquestions.indexOf(row.id)==-1){
        this.requestquestions.push(row.id)
      } else {
        this.requestquestions.splice(this.requestquestions.indexOf(row.id),1)
      }
    },
    showMe(){
      axios.get("/api/reviewrequest/all")
        .then((response) => {
          this.reviewrequest =  response.data
          if(this.review_id!=0){
            this.description = this.reviewrequest.filter(req=>req.id==this.review_id)[0].description
            this.requestquestions = JSON.parse(this.reviewrequest.filter(req=>req.id==this.review_id)[0].questions)
            if(this.requestquestions==null){
              this.requestquestions=[]
            }
          }else {
            this.description = ""
            this.requestquestions=[]

          }
      })
        .catch(() => {
        });
        axios.get("/api/reviewquestions/all")
        .then((response) => {
          this.reviewquestions =  response.data
        })
        .catch(() => {
        });  
    },
    close_modal() {
      this.$bvModal.hide('BSReviewModalID')
    },
  },
}    
</script>
<style>

.questionsselected {
display:flex;
flex-direction: row;
width:100%;

}
.selectedquestion {
border:2px solid black;
 width:30px;
 height:30px;
 margin:5px;
 text-align:center;
 user-select:none;
 
}
.over{
  border:2px red solid !important;
}
</style>